import React, { Fragment, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import axios from "axios";
import AddUser from "./add-user.component";
import AdminResetPassword from "./admin-reset-password";

const ShowUsers = ({ admin }) => {
  const toast = useRef(null);
  const [users, setUsers] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    getAllUsers();
  }, []);

  useEffect(() => {
    if (admin.isNewUserAdded === 1) getAllUsers();
  }, [admin.isNewUserAdded]);

  const getAllUsers = async (e) => {
    try {
      const res = await axios.get("/api/v1/users", {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      setUsers(res.data.data.data);
    } catch (err) {}
  };
  // handlers listed  below
  const handleEnable = async (row) => {
    console.log("Enable pressed and row is ", row);
    let active = !row.active;
    try {
      const res = await axios.patch(
        `/api/v1/users/active/${row._id}`,
        { active },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        },
      );

      setUsers(res.data.data.data);
    } catch (err) {}
  };

  const handleSeeder = async () => {
    try {
      const res = await axios.patch("/api/v1/seeders", {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
    } catch (err) {}
  };

  const header = (
    <div className='p-d-flex p-jc-between'>
      <p className='m-0 fontl'>Users</p>
      <AddUser />
      {/* <Button label='Run Seeder' onClick={handleSeeder} /> */}
      <span className='p-input-icon-left'>
        <i className='pi pi-search' />
        <InputText
          type='search'
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder='Search...'
        />
      </span>
    </div>
  );

  const activeDisabled = (rowData) => {
    return rowData.active === true ? "Active" : "Disabled";
  };
  const disableButton = (rowData) => {
    return (
      <Button
        className={
          rowData.active
            ? "p-button-danger p-button-sm"
            : "p-button-success p-button-sm"
        }
        label={rowData.active === true ? "Disable User" : "Enable User"}
        onClick={() => handleEnable(rowData)}
        disabled={rowData.role === "admin"}
      />
    );
  };

  const resetButton = (rowData) => {
    return (
      <Fragment>
        <Button
          className='p-button-info p-button-sm'
          label='Reset Password'
          // onClick={() => handleShowDialog(user)}
          onClick={() => {
            console.log("Temp click rowData", rowData);
            setSelectedUser(rowData);
            setShowDialog(true);
          }}
          disabled={rowData.role === "admin"}
        />
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Toast ref={toast} />
      <div className='p-shadow-12'>
        <Card className='small-table' id='admin-user'>
          <DataTable
            value={users}
            dataKey='_id'
            paginator={users.length > 10}
            paginatorTemplate='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
            currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            header={header}
            globalFilter={globalFilter}
          >
            <Column
              field='email'
              header='Email'
              sortable={true}
              style={{ width: "25%" }}
            />
            <Column
              field='role'
              header='Role'
              sortable={true}
              style={{ width: "15%" }}
            />
            <Column
              field='active'
              header='User Status'
              body={activeDisabled}
              sortable={true}
              style={{ width: "15%" }}
            />
            <Column
              body={resetButton}
              header='Reset Password'
              style={{ width: "15%" }}
            />
            <Column
              body={disableButton}
              header='Disable User'
              style={{ width: "15%" }}
            />
          </DataTable>
          <AdminResetPassword
            showDialog={showDialog}
            setShowDialog={setShowDialog}
            selectedUser={selectedUser}
          />
        </Card>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  admin: state.admin,
});

export default connect(mapStateToProps, null)(ShowUsers);
